import styled from "styled-components";
import { AppBar as MuiAppBar } from "@material-ui/core";

const AppBar = styled(MuiAppBar)`
    margin: -20px -20px 20px -20px;
    width: inherit;
`;

export default AppBar;
